import React from 'react';

import SpinnerDiv from "./SpinnerDiv";

export default class Dropdown extends React.Component
{

    // Entry properties
    //
    // mode : 'list' - Just act like a dropdown with each role itemised
    //        'filter' - act as a drop down filter list, including an 'ALL' option
    //
    // defaultItemId : The user ID of the user to select, if supplied
    // user_id : The user ID of the ESW or user who is calling this

    static get defaultProps()
    {
        var v =
            {
                defaultItemId: 0,
                value: 0,
                notSetDisplayValue: '',
                emptyValue: 0,
                valueLookup: 'byIndex',
                suppressLabel: false
            } ;

        return v ;
    }

    constructor(props)
    {
        super(props);

        this.isDirty = this.isDirty.bind(this) ;
        this.setDirty = this.setDirty.bind(this) ;
    }

    isDirty()
    {
        return this.state.dirty ;
    }

    setDirty ( value )
    {
        this.setState ({dirty: value}) ;
    }

    isValid()
    {
        return this.isValueValid ( this.getValue() ) ;
    }

    sendChangeNotification()
    {
        if ( this.state.dirty == false )
        {
            if ( this.props.onDirty != null )
            {
                // Send a dirty notification if required, and only the first time we change
                this.props.onDirty() ;
            }
        }
    }

    optionDropdown(id)
    {
        var lineList=[];

        if ( this.props.suppressLabel != true )
        {
            lineList.push(React.createElement('label', {
                key: 'DropdownLabel' + this.props.id,
                htmlFor: this.props.id,
                className: 'col-form-label'
            }, this.props.label));
        }

        lineList.push( this.dropdown_select(id));

        if ( this.props.displayErrors == true )
        {
            lineList.push ( this.errorDiv(true) ) ;
        }


        return lineList ;
    }

    optionDropdownLoading()
    {
        var lineList=[];

        if ( this.props.suppressLabel != true )
        {
            lineList.push(React.createElement('label', {
                key: 'DropdownLabelLoading' + this.props.id,
                htmlFor: this.props.id,
                className: 'col-form-label'
            }, this.props.label));
        }

        lineList.push( React.createElement('div',{ key: 'DropdownForm'+this.props.id , className: 'form-control' },React.createElement(SpinnerDiv, { size: 'sk-fading-small'})));

        if ( this.props.displayErrors == true )
        {
            lineList.push ( this.errorDiv(true) ) ;
        }

        return React.createElement ( 'div', {key: 'DropdownInputGroup'+this.props.id , className: 'input-group'}, lineList );
    }

    errorDiv ()
    {
        var errmsg = "Invalid Value" ;

        if ( this.props.errorText != null )
        {
            if ( this.props.errorText.length != 0)
            {
                errmsg = this.props.errorText ;
            }
        }

        if ( this.props.displayErrors == true && this.isValid() != true )
        {
            var className = 'input-error-visible' ;
        }
        else
        {
            var className = 'input-error-invisible' ;
        }

        return React.createElement ('div', {  key: 'DropdownErrorDiv'+this.props.id , className: className} , errmsg ) ;
    }

    getText()
    {
        let v = '' ;

        if ( this.state.items != null )
        {
            var i = 0 ;
            var len = this.state.items.length;
            var row = null ;

            for (i=0; i<len; ++i)
            {
                row = this.state.items[i];

                if ( row.id == this.state.currentValue )
                {
                    v = row.desc ;

                    break ;
                }
            }
        }

        return v ;
    }

    getCurrentText()
    {
        let v = 'Not Set' ;

        if ( this.props.emptyValue != null && this.state.currentValue == this.props.emptyValue )
        {
            v = this.props.notSetDisplayValue ;
        }
        else
        {
            if ( this.props.valueLookup == 'byValue')
            {
                v = this.findValueText ( this.getValue()  ) ;
            }
            else
            {
                v = this.getText() ;
            }
        }

        return v;
    }

    readOnlyField(id)
    {
        var lineList=[];

        if ( this.props.suppressLabel != true )
        {
            lineList.push (React.createElement('label', {  key: 'DropdownReadonlyLabel'+this.props.id , htmlFor: this.props.id, className: 'col-form-label'}, this.props.label ));
        }

        let style = {};

        style.borderColor = '#ecf3f9' ;
        style.paddingLeft = '6px';
        style.color = '#428bcd';

        if ( this.props.displayErrors == true && !this.isValid())
        {
            style.borderColor = '#ff0000' ;
        }

        lineList.push ( React.createElement('input',{
            ref: 'inputReference',
            key: 'DropdownReadOnly'+this.props.id ,
            readOnly: 'readonly',
            type: 'text',
            className: 'form-control',
            value: this.getCurrentText(),
            style: style,
            tabIndex: this.props.tabIndex,
            id: this.props.id,
            name: this.props.name
        })) ;

        if ( this.props.displayErrors == true )
        {
            lineList.push ( this.errorDiv(true) ) ;
        }

        return lineList ;
    }
};
